import { ChangeDetectionStrategy, Component, OnInit, computed, inject, input } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { CmsEditorialArticle, CmsTaxonomyGeneral } from '@fcom/core-api';
import { SchemaService } from '@fcom/common/services/schema/schema.service';
import { CmsPicture } from '@fcom/core-api/interfaces/cms-interface';
import { toISOStringWithTzOffset } from '@fcom/core/utils/date';

@Component({
  selector: 'fin-article-bluewings',
  templateUrl: './article-bluewings.component.html',
  styleUrls: ['./article-bluewings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ArticleBluewingsComponent implements OnInit {
  private schemaService = inject(SchemaService);
  private document = inject<Document>(DOCUMENT);

  readonly CmsTaxonomyGeneral = CmsTaxonomyGeneral;

  content = input.required<CmsEditorialArticle>();

  hasUpdatedTag = computed<boolean>((): boolean =>
    this.content().subjectTaxonomyTags.some(
      (tag) => tag === CmsTaxonomyGeneral.TRAVEL_UPDATE_UPDATED || tag === CmsTaxonomyGeneral.BLUEWINGS_ARTICLE_UPDATED
    )
  );

  publicationDate = computed((): number => {
    const content: CmsEditorialArticle = this.content();
    const firstPublished: number | undefined = content.localSettings?.firstPublished;

    if (typeof firstPublished === 'number') {
      return firstPublished;
    }

    return this.hasUpdatedTag()
      ? (content.creationDate ?? content.externallyDisplayedDate)
      : content.externallyDisplayedDate;
  });

  ngOnInit(): void {
    const content: CmsEditorialArticle = this.content();
    const picture: CmsPicture | null = content.media.length ? (content.media[0] as CmsPicture) : null;

    this.schemaService.addArticleSchema({
      id: this.document.location.href,
      headline: content.teaserTitle,
      description: content.teaserText,
      dateModified: toISOStringWithTzOffset(content.externallyDisplayedDate),
      datePublished: toISOStringWithTzOffset(this.publicationDate()),
      image: picture?.data
        ? {
            url: picture.data,
            width: picture.width?.toString() ?? '',
            height: picture.height?.toString() ?? '',
          }
        : undefined,
    });
  }
}
